import React from 'react'

import { useIsMobile } from '../../hooks/useBreakpoint'

import { BaseTile, SpecialistTilesContainer, TimeslotTilesContainer } from './styles'

type LoadingTilesProps = {
  variant: 'specialist' | 'timeslot'
  numTiles?: number
}

const LoadingTilesSkeleton: React.FC<React.PropsWithChildren<LoadingTilesProps>> = ({
  variant,
  numTiles = 5,
}) => {
  const isMobile = useIsMobile()

  if (variant === 'specialist') {
    return (
      <SpecialistTilesContainer>
        {Array(numTiles)
          .fill(0)
          .map((_, i) => (
            <BaseTile key={`loadingTile-${i}`} skeleton minHeight="105px" />
          ))}
      </SpecialistTilesContainer>
    )
  }

  return (
    <TimeslotTilesContainer>
      {Array(numTiles)
        .fill(0)
        .map((_, i) => (
          <BaseTile key={`loadingTile-${i}`} skeleton minHeight={isMobile ? '155px' : '95px'} />
        ))}
    </TimeslotTilesContainer>
  )
}

export default LoadingTilesSkeleton
